import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import DualListBox from "react-dual-listbox";
import { Input, Label } from "reactstrap";
import Icon from "../icon/Icon";

const buttonText = {
  moveLeft: <span className="dual-listbox__button">Remove</span>,
  moveAllLeft: <span className="dual-listbox__button">Remove all</span>,
  moveRight: <span className="dual-listbox__button">Add</span>,
  moveAllRight: <span className="dual-listbox__button">Add all</span>,
  moveDown: <span className="fa fa-chevron-down" />,
  moveUp: <span className="fa fa-chevron-up" />,
  moveTop: <span className="fa fa-double-angle-up" />,
  moveBottom: <span className="fa fa-double-angle-down" />,
};

const buttonIcon = {
  moveLeft: (
    <span className="dual-listbox__button">
      <Icon name="chevron-left" />
    </span>
  ),
  moveAllLeft: (
    <span className="dual-listbox__button">
      <Icon name="chevrons-left" />
    </span>
  ),
  moveRight: (
    <span className="dual-listbox__button">
      <Icon name="chevron-right" />
    </span>
  ),
  moveAllRight: (
    <span className="dual-listbox__button">
      <Icon name="chevrons-right" />
    </span>
  ),
  moveDown: <span className="fa fa-chevron-down" />,
  moveUp: <span className="fa fa-chevron-up" />,
  moveTop: <span className="fa fa-double-angle-up" />,
  moveBottom: <span className="fa fa-double-angle-down" />,
};

const ReactDualList = ({
  options,
  icon,
  canFilter,
  preSelected,
  handleSelectedState,
  selectedZonesLastModified,
  setSelectedelectedZonesLastModified,
}) => {
  const [data, setData] = useState(options);
  const [filterText, setFilterText] = useState("");
  const [selected, setSelected] = useState(
    preSelected.length > 0 ? preSelected : options.map((option) => option.value)
  );
  const [selectedZones, setSelectedZones] = useState(selectedZonesLastModified);

  const zones = {
    "All Zones": [
      "AL",
      "AK",
      "AZ",
      "AR",
      "CA",
      "CO",
      "CT",
      "DE",
      "FL",
      "GA",
      "HI",
      "ID",
      "IL",
      "IN",
      "IA",
      "KS",
      "KY",
      "LA",
      "ME",
      "MD",
      "MA",
      "MI",
      "MN",
      "MS",
      "MO",
      "MT",
      "NE",
      "NV",
      "NH",
      "NJ",
      "NM",
      "NY",
      "NC",
      "ND",
      "OH",
      "OK",
      "OR",
      "PA",
      "RI",
      "SC",
      "SD",
      "TN",
      "TX",
      "UT",
      "VT",
      "VA",
      "WA",
      "WV",
      "WI",
      "WY",
    ],
    Z0: ["CT", "ME", "MA", "NH", "NJ", "RI", "VT"],
    Z1: ["DE", "NY", "PA"],
    Z2: ["MD", "NC", "SC", "VA", "WV"],
    Z3: ["AL", "FL", "GA", "MS", "TN"],
    Z4: ["IN", "KY", "MI", "OH"],
    Z5: ["IA", "MN", "MT", "ND", "SD", "WI"],
    Z6: ["IL", "KS", "MO", "NE"],
    Z7: ["AR", "LA", "OK", "TX"],
    Z8: ["AZ", "CO", "ID", "NV", "NM", "UT", "WY"],
    Z9: ["CA", "OR", "WA", "AK"],
  };

  const handleZoneChange = (zone) => {
    let sZones = [...selectedZones];
    if (zone === "All Zones") {
      sZones = [];
      setSelected([]);
      handleSelectedState([]);
    } else {
      if (sZones.indexOf("All Zones") >= 0) {
        sZones.splice(sZones.indexOf("All Zones"), 1);
        setSelected([]);
        handleSelectedState([]);
      }
    }

    if (sZones.includes(zone)) {
      sZones.splice(sZones.indexOf(zone), 1);
      // let selectedOptions = [...selected];
      let selectedOptions = selected.filter((option) => {
        return !zones[zone].includes(option);
      });
      setSelected(selectedOptions);
      handleSelectedState(selectedOptions);
    } else {
      sZones.push(zone);
    }
    setSelectedZones(sZones);
    setSelectedelectedZonesLastModified(sZones);
  };

  const onListChange = (selected) => {
    setSelected(selected);
    handleSelectedState(selected);
  };

  // Filter options based on zone and search text
  useEffect(() => {
    let filteredOptions = options;

    // Apply zone filter
    if (!selectedZones.includes("All Zones")) {
      filteredOptions = options.filter((option) =>
        // if(option.)
        selectedZones.some((selectedZone) => {
          return zones[selectedZone].includes(option.value);
        })
      );
    }

    // Apply search filter
    if (filterText !== "") {
      filteredOptions = filteredOptions.filter((item) =>
        item.label.toLowerCase().includes(filterText.toLowerCase())
      );
    }

    setData(filteredOptions);
  }, [filterText, selectedZones]);

  // useEffect(() => {

  //   // setSelected([]);
  // 	// handleSelectedState([]);

  // }, [selectedZones]);

  // // Validate pre-selected items when data changes
  // useEffect(() => {
  //   const validSelected = preSelected.filter((value) =>
  //     options.some((option) => option.value === value)
  //   );
  //   setSelected(validSelected);
  // }, [preSelected]);

  return (
    <div className="dual-listbox w-100 d-flex justify-content-center align-items-center">
      <div
        className="d-flex p-3 gap-4 fs-18px"
        style={{ marginBottom: "38px" }}
      >
        <ul className="custom-control-group">
          {Object.keys(zones).map((zone) => (
            <li>
              <div className="custom-control custom-checkbox custom-control-pro custom-control-pro-icon no-control">
                <Input
                  type="checkbox"
                  name="zone"
                  className="custom-control-input"
                  checked={selectedZones.includes(zone)}
                  onChange={() => handleZoneChange(zone)}
                  aria-label={`Select zone ${zone}`}
                  id={zone} // It's a good practice to add an id to radio buttons
                  style={{
                    cursor: "pointer",
                  }}
                />
                <Label for={zone} className="custom-control-label px-3">
                  {zone}
                </Label>
              </div>
            </li>
          ))}
        </ul>
      </div>
      {canFilter && (
        <div className="form-control-wrap w-md-auto mb-3">
          <div className="form-icon form-icon-right">
            {filterText !== "" && (
              <label onClick={() => setFilterText("")}>
                <Icon name="cross" />
              </label>
            )}
          </div>
          <input
            className="dual-listbox__search"
            placeholder="Search"
            value={filterText}
            onChange={(e) => setFilterText(e.target.value)}
          />
        </div>
      )}

      <div className="d-flex flex-column align-items-center">
        <DualListBox
          options={data}
          selected={selected}
          icons={icon ? buttonIcon : buttonText}
          onChange={onListChange}
          showHeaderLabels={true}
        />
      </div>
    </div>
  );
};

ReactDualList.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
  icon: PropTypes.bool,
  canFilter: PropTypes.bool,
  preSelected: PropTypes.arrayOf(PropTypes.string),
  handleSelectedState: PropTypes.func.isRequired,
};

ReactDualList.defaultProps = {
  icon: false,
  canFilter: false,
  preSelected: [],
};

export default ReactDualList;
